import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';
@Component({
  selector: 'app-response-error',
  templateUrl: './response-error.component.html',
  styleUrls: ['./response-error.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class ResponseErrorComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  status = '404';
  message = 'Resource not found';
  ngOnInit(): void {
    const status = this.route.snapshot.queryParams['status'];
    if (status) {
      this.status = status;
    }
    const message = this.route.snapshot.queryParams['message'];
    if (message) {
      this.message = message;
    }
  }

  toHome() {
    this.router.navigate(['/home']);
  }
}
